import styled from "styled-components"

const ManagingStyled = styled.div`
  padding-bottom: 70px;
  @media (max-width: 880px) {
    padding-bottom: 70px;
  }
  .managing {
    &__container {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      max-width: 920px;
      &:after {
        content: "";
        display: block;
        clear: both;
      }
    }
    &__item {
      box-shadow: 0px 5px 15px rgba(112, 112, 112, 0.2);
      padding-bottom: 75px;
      /* margin-bottom: 35px; */
      margin: 0 20px 25px;
      /* -webkit-transition: 0.3s all; */
      /* transition: 0.3s all; */
      height: 90%;
      max-width: 420px;
      width: 100%;
      transition: 0.3s all;
      &:hover {
        transform: scale(1.05);
      }
      @media (max-width: 940px) {
        max-width: 390px;
      }
      @media (max-width: 880px) {
        max-width: 100%;
      }
      a {
        cursor: pointer;
      }
      &:nth-of-type(1) {
        /* float: left; */
        @media (max-width: 880px) {
          float: initial;
          margin: 0 0 35px;
        }
      }
      &:nth-of-type(2) {
        /* float: right; */
        @media (max-width: 880px) {
          float: initial;
          margin: 0 0 35px;
        }
      }
      &.active {
        max-width: 870px;
        float: inherit;
      }
    }
    &__header {
      padding: 25px 55px 0 33px;
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      @media (max-width: 500px) {
        flex-direction: column-reverse;
        width: 100%;
        justify-content: center;
        align-items: center;
        text-align: center;
        padding: 25px 20px 0;
      }
      &:after {
        content: "";
        position: absolute;
        height: 1px;
        left: 0;
        bottom: -1px;
        right: 100px;
        background: #d8d8d8;
        @media (max-width: 500px) {
          content: unset;
        }
      }
    }
    &__name {
      font-size: 19px;
      font-weight: 500;
      margin-bottom: 0;
      @media (max-width: 500px) {
        line-height: 1.9;
      }
      span {
        display: block;
        font-size: 14px;
        font-weight: 300;
      }
    }
    &__img {
      margin-top: 4px;
    }
    &__email {
      /* font-size: 14px !important; */
      word-wrap: break-word;
    }
    &__linkedin {
      padding-top: 10px;
      transition: 0.3s all;
      &:hover {
        opacity: 0.5;
      }
    }
    &__body {
      padding: 0 45px;
      @media (max-width: 500px) {
        padding: 0 20px;
      }
      &__small {
        text-align: center;
        p {
          font-size: 17px;
          margin: 0;
          padding: 26px 0 36px;
        }
        span {
          font-weight: 300 !important;
        }
      }
    }
  }
`

export default ManagingStyled
